import axios from 'axios';
import 'cleave.js';
import app from './createVue';


window.axios = axios;

app.mount('#app');
